import { CSSProperties, useState } from "react";
import { useHistory } from "react-router";
import { Button, Input } from "semantic-ui-react";

const LoginPageContainerStyle: CSSProperties = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	height: "100%",
};

const InputContainerStyle: CSSProperties = {
	width: 300,
	height: 100,
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-evenly",
};

const LoginPage = () => {
	const history = useHistory();
	const [localSchoolID, setLocalSchoolID] = useState("");

	function onLoginClick() {
		history.push(`/${localSchoolID}`);
	}

	return (
		<div style={LoginPageContainerStyle}>
			<div style={InputContainerStyle}>
				<Input
					placeholder="School ID"
					value={localSchoolID}
					onChange={(_, d) => setLocalSchoolID(d.value)}
				/>
				<Button onClick={onLoginClick}>LOGIN</Button>
			</div>
		</div>
	);
};

export default LoginPage;
